import * as XLSX from "xlsx";

function formatHeader(header: string): string {
  return header
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
}

export function downloadExcelFile(
  data: Record<string, any>[],
  fileName: string,
): void {
  try {
    if (!data || data.length === 0) {
      throw new Error("No data provided");
    }

    const formattedData = data.map((item) => {
      const formattedItem: Record<string, any> = {};
      for (const key in item) {
        const newKey = formatHeader(key);
        formattedItem[newKey] = item[key];
      }
      return formattedItem;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  } catch (error) {
    console.log("error: ", error);
  }
}
